import { z } from 'zod';
import { featureDisabledResponseSchema, } from './helpers';
export { featureDisabledResponseSchema };
/**
 * Bitbucket connection status values
 */
export const bitbucketConnectionStatusSchema = z.enum([
    'none',
    'active',
    'disconnected',
]);
/**
 * Bitbucket health state values derived from connection + token status
 */
export const bitbucketHealthStateSchema = z.enum([
    'active',
    'expiring_soon',
    'expired',
    'invalid_token',
    'insufficient_permissions',
    'workspace_inaccessible',
]);
// ============================================================================
// STATUS
// ============================================================================
export const bitbucketStatusResponseSchema = z.object({
    enabled: z.boolean(),
    connectionStatus: bitbucketConnectionStatusSchema,
    connected: z.boolean(),
    workspaceName: z.string().optional(),
    workspaceSlug: z.string().optional(),
    healthState: bitbucketHealthStateSchema.optional(),
    tokenExpiresAt: z.string().nullable().optional(),
    tokenExpiringSoon: z.boolean().optional(),
    connectedAt: z.string().optional(),
    importedCount: z.number().optional(),
});
// ============================================================================
// CONNECT
// ============================================================================
export const bitbucketConnectRequestSchema = z.object({
    accessToken: z.string().min(1, 'Access token is required'),
    tokenExpiresAt: z.string().nullable(),
});
export const bitbucketConnectSuccessSchema = z.object({
    success: z.literal(true),
    workspaceName: z.string(),
    workspaceSlug: z.string(),
});
export const bitbucketConnectResultSchema = z.union([
    bitbucketConnectSuccessSchema,
    featureDisabledResponseSchema,
]);
// ============================================================================
// DISCONNECT
// ============================================================================
export const bitbucketDisconnectSuccessSchema = z.object({
    success: z.literal(true),
});
export const bitbucketDisconnectResultSchema = z.union([
    bitbucketDisconnectSuccessSchema,
    featureDisabledResponseSchema,
]);
// ============================================================================
// UPDATE TOKEN
// ============================================================================
export const bitbucketUpdateTokenRequestSchema = z.object({
    accessToken: z.string().min(1, 'Access token is required'),
    tokenExpiresAt: z.string().nullable(),
});
export const bitbucketUpdateTokenSuccessSchema = z.object({
    success: z.literal(true),
    workspaceName: z.string(),
    workspaceSlug: z.string(),
});
export const bitbucketUpdateTokenResultSchema = z.union([
    bitbucketUpdateTokenSuccessSchema,
    featureDisabledResponseSchema,
]);
// ============================================================================
// SYNC
// ============================================================================
export const bitbucketSyncResponseSchema = z.object({
    enabled: z.literal(true).optional(),
    success: z.boolean(),
    usersAdded: z.number(),
    usersRemoved: z.number(),
    errorMessage: z.string().optional(),
    alreadyRunning: z.boolean().optional(),
});
export const bitbucketSyncResultSchema = z.union([
    bitbucketSyncResponseSchema,
    featureDisabledResponseSchema,
]);
export const bitbucketSyncStatusResponseSchema = z.object({
    enabled: z.boolean(),
    lastSyncAt: z.string().optional(),
    lastSyncStatus: z.enum(['completed', 'failed']).optional(),
    lastSyncType: z.enum(['manual', 'periodic']).optional(),
    isRunning: z.boolean(),
    importedCount: z.number(),
    linkedCount: z.number(),
});
// ============================================================================
// IMPORTED USERS
// ============================================================================
export const bitbucketUserDataSchema = z.object({
    uuid: z.string(),
    accountId: z.string(),
    displayName: z.string(),
    nickname: z.string(),
    email: z.string().nullish(),
    avatarUrl: z.string().nullish(),
});
export const bitbucketImportedUserSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    provider: z.literal('bitbucket'),
    providerUserId: z.string(),
    providerUserData: bitbucketUserDataSchema,
    status: z.string(),
    kirinUserId: z.string().nullable(),
    importedAt: z.string(),
    linkedAt: z.string().nullable(),
    removedFromProviderAt: z.string().nullable(),
});
export const bitbucketImportedUsersResponseSchema = z.object({
    enabled: z.literal(true).optional(),
    users: z.array(bitbucketImportedUserSchema),
    total: z.number(),
});
export const bitbucketImportedUsersResultSchema = z.union([
    bitbucketImportedUsersResponseSchema,
    featureDisabledResponseSchema,
]);
//# sourceMappingURL=bitbucket.js.map